import React from 'react';
import { Icon, Header } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import './index.scss';

const Line = ({ line, currentTime = 0, onSelectCall, onUnholdCall, onAnswer, onReject, onTransferCall, answerDisabled }) => {
    const leg = line.call_type === "transfer" ? 
        line?.legs?.find(leg => leg.channel_uuid === line.channel_uuid)
            : line?.legs?.find(leg => leg.channel_uuid === line.uuid);
    const isHardPhone = !!!line?.session_id;
    return (
        <div className={`OfficeView__AdditionalLine${isHardPhone ? '--hardphone' : line.actionButtons?.hold ? '--hold' : line.connected > 0 ? '--active' : '--ringing'}`}>
            <div className='OfficeView__LineLeft'>
                <Icon size='large'  className='fa-solid fa-arrows-up-down-left-right OfficeView__Move' onClick={() => onTransferCall(line.uuid)}/>
                <Icon size='large' className={`fa-solid fa-phone-${line.connected > 0 ? 'plus' : 'volume'} OfficeView__Phone`}/>
            </div>
            <div className='OfficeView__LineMiddle' onClick={() => onSelectCall(line.uuid, leg.phone)}>
                <Header as='h3' style={{fontWeight: 100, marginLeft: 15}}><a>{line.name}</a></Header>
            </div>
            <div className='OfficeView__LineRight'>
            {line.connected > 0 ? (
                <>
                <Header as='h3' style={{fontWeight: 100, display: 'inline-block', margin: 0 }}>
                    {PhoneUtil.timeTicker(
                        currentTime > 0 ?
                            currentTime - line.connected + (line.drift || 0) 
                                : 0
                    )}
                </Header>
                {line.actionButtons?.hold && (
                    <Icon size='large' className='fa-solid fa-play OfficeView__Hold' onClick={() => onUnholdCall(line.uuid, line.session_id, leg.phone)}/>
                )}
                </>
            ) : (
                <>
                    <Icon size='large' className='fa-solid fa-phone OfficeView__Answer' disabled={answerDisabled} onClick={() => onAnswer(line.uuid, line.channel_uuid, line.session_id, leg.phone)} />
                    <Icon size='large' className='fa-solid fa-phone-hangup OfficeView__Reject' onClick={() => onReject(line.uuid, line.channel_uuid)} />
                </>
            )}
            </div>
        </div>
)}

export default Line;

